import {
  Avatar,
  Grid,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import { getFromStorage } from "../../../util/StorageUtil";
import BrowseGalleryIcon from "@mui/icons-material/BrowseGallery";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import BarChartIcon from "@mui/icons-material/BarChart";
import AssistantPhotoIcon from "@mui/icons-material/AssistantPhoto";
import StarIcon from "@mui/icons-material/Star";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../../components/PageHeader";
import { getKeywordPortrait } from "../../../api/specialization/KeywordSpecializationAPI";
import React from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { WordBarElement } from "../../../components/WordBarElement";
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt";
import CategoryIcon from "@mui/icons-material/Category";
import { Chart, registerables } from "chart.js";
import { curveLineOptions } from "../../../util/ChartStyleUtil";

import { singleField, sumByField } from "../../../util/ArrayUtil";
import NumberBox from "../../../components/NumberBox";
import { Line } from "react-chartjs-2";
import RankingNumber from "../../../components/RankingNumber";
import { SentimentGauge } from "../../../components/SentimentGauge";
import { WordBubbleWrapper } from "../../../components/WordBubbleWrapper";
import { KeywordPairPopup } from "./popup/KeywordPairPopup";

Chart.register(...registerables);
export function KeywordPortraitPage() {
  const { t } = useTranslation(["common", "whatsnew", "keyword"]);
  const [showNewsDetailPopup, setShowNewsDetailPopup] = useState(false);
  const [chosenNewsID, setChosenNewsID] = useState(0);
  const [keywordPairDetailPopup, setKeywordPairDetailPopup] = useState(false);
  const [currentText, setCurrentText] = useState(
    getFromStorage("homePageData12")
      ? getFromStorage("homePageData12").popularKeywords[0].token
      : "Việt Nam"
  );

  const [adjacentKeyword, setAdjacentKeyword] = useState("");
  const [chosenKeyword, setChosenKeyword] = useState(
    getFromStorage("homePageData12")
      ? getFromStorage("homePageData12").popularKeywords[0].token
      : "Việt Nam"
  );

  const [pageData, setPageData] = useState({});

  useEffect(() => {
    getKeywordPortrait(chosenKeyword, 10)
      .then((res) => {
        setPageData(res);
      })
      .catch((err) => {});
  }, [chosenKeyword]);

  console.log(pageData);

  var keywordDetail = pageData as any;
  var appearancesOnTitleToday = keywordDetail.appearancesOnTitleToday
    ? keywordDetail.appearancesOnTitleToday
    : 0;
  var appearancesOnTitle = keywordDetail.appearancesOnTitle
    ? keywordDetail.appearancesOnTitle
    : 0;
  if (Object.keys(keywordDetail).length <= 0) {
    return <div></div>;
  }
  var summaries = keywordDetail.summary ? keywordDetail.summary : [];
  var summary = "";
  if (summaries.length > 0) {
    summary = summaries[0].summary;
  }
  var appearancesToday = keywordDetail.appearances
    ? singleField(keywordDetail.appearances, "count")[0]
    : 0;
  var appearancesThisWeek = keywordDetail.appearances
    ? sumByField(keywordDetail.appearances, "count")
    : 0;
  var averageTimeOnHeadlines = keywordDetail.averageTimeOnHeadlines
    ? keywordDetail.averageTimeOnHeadlines
    : 0;
  var recentNegatives = keywordDetail.recentNegatives
    ? keywordDetail.recentNegatives
    : [];
  var recentPositives = keywordDetail.recentPositives
    ? keywordDetail.recentPositives
    : [];
  var headlines = keywordDetail.longestTimeOnHeadlines
    ? keywordDetail.longestTimeOnHeadlines
    : [];
  var headlinesList = headlines.slice(0, 3).map((source: any) => {
    return (
      <ListItem
        alignItems="flex-start"
        className="source-item slide-from-bottom"
        onClick={() => {
          setChosenNewsID(source["id"]);
          setShowNewsDetailPopup(true);
        }}
      >
        <ListItemAvatar>
          <Avatar
            alt={source["source"]}
            src={
              "https://www.google.com/s2/favicons?domain=" +
              new URL(source["url"]).hostname +
              "/favicon.ico"
            }
          />
        </ListItemAvatar>
        <ListItemText
          style={{ textAlign: "justify" }}
          primary={source["title"]}
          primaryTypographyProps={{
            fontSize: "14px",
            color: "#1976d2",
            fontWeight: 500,
          }}
          secondaryTypographyProps={{
            fontSize: "12px",
          }}
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: "inline", fontSize: "12px" }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                {source["author"]}
              </Typography>
              {(source["author"] ? " - " : "") + source["description"]}
            </React.Fragment>
          }
        />
      </ListItem>
    );
  });
  var recentPositiveList = recentPositives.slice(0, 3).map((source: any) => {
    return (
      <ListItem
        alignItems="flex-start"
        className="source-item slide-from-bottom"
        onClick={() => {
          setChosenNewsID(source["id"]);
          setShowNewsDetailPopup(true);
        }}
      >
        <ListItemAvatar>
          <Avatar
            alt={source["source"]}
            src={
              "https://www.google.com/s2/favicons?domain=" +
              new URL(source["url"]).hostname +
              "/favicon.ico"
            }
          />
        </ListItemAvatar>
        <ListItemText
          style={{ textAlign: "justify" }}
          primary={source["title"]}
          primaryTypographyProps={{
            fontSize: "14px",
            color: "#1976d2",
            fontWeight: 500,
          }}
          secondaryTypographyProps={{
            fontSize: "12px",
          }}
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: "inline", fontSize: "12px" }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                {source["author"]}
              </Typography>
              {(source["author"] ? " - " : "") + source["description"]}
            </React.Fragment>
          }
        />
      </ListItem>
    );
  });
  var recentNegativeList = recentNegatives.slice(0, 3).map((source: any) => {
    return (
      <ListItem
        alignItems="flex-start"
        className="source-item slide-from-bottom"
        onClick={() => {
          setChosenNewsID(source["id"]);
          setShowNewsDetailPopup(true);
        }}
      >
        <ListItemAvatar>
          <Avatar
            alt={source["source"]}
            src={
              "https://www.google.com/s2/favicons?domain=" +
              new URL(source["url"]).hostname +
              "/favicon.ico"
            }
          />
        </ListItemAvatar>
        <ListItemText
          style={{ textAlign: "justify" }}
          primary={source["title"]}
          primaryTypographyProps={{
            fontSize: "14px",
            color: "#1976d2",
            fontWeight: 500,
          }}
          secondaryTypographyProps={{
            fontSize: "12px",
          }}
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: "inline", fontSize: "12px" }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                {source["author"]}
              </Typography>
              {(source["author"] ? " - " : "") + source["description"]}
            </React.Fragment>
          }
        />
      </ListItem>
    );
  });
  var relatedTopics = keywordDetail.relatedTopics
    ? keywordDetail.relatedTopics.sort((a: any, b: any) => {
        return b.points - a.points;
      })
    : [];
  var relatedAdjectives =
    keywordDetail.relatedAdjectives.length &&
    keywordDetail.relatedAdjectives.length > 0
      ? keywordDetail.relatedAdjectives.sort((a: any, b: any) => {
          return b.count - a.count;
        })
      : [];
  var relatedKeywords =
    keywordDetail.relatedKeywords.length &&
    keywordDetail.relatedKeywords.length > 0
      ? keywordDetail.relatedKeywords.sort((a: any, b: any) => {
          return b.count - a.count;
        })
      : [];
  var relatedPeople =
    keywordDetail.relatedPeople.length && keywordDetail.relatedPeople.length > 0
      ? keywordDetail.relatedPeople.sort((a: any, b: any) => {
          return b.count - a.count;
        })
      : [];
  var relatedLocations =
    keywordDetail.relatedLocations.length &&
    keywordDetail.relatedLocations.length > 0
      ? keywordDetail.relatedLocations.sort((a: any, b: any) => {
          return b.count - a.count;
        })
      : [];
  var relatedOrganizations =
    keywordDetail.relatedOrganizations.length &&
    keywordDetail.relatedOrganizations.length > 0
      ? keywordDetail.relatedOrganizations.sort((a: any, b: any) => {
          return b.count - a.count;
        })
      : [];
  var relatedKeywordList = relatedKeywords.slice(0, 5).map((keyword: any) => {
    var barLength = (keyword.count / relatedKeywords[0].count) * 100;
    return (
      <WordBarElement
        word={keyword.keyword}
        scaledNumber={barLength}
        icon={
          <AddCircleIcon
            color={
              keyword.keyword == relatedKeywords[0].keyword
                ? "error"
                : "success"
            }
          />
        }
        color={
          keyword.keyword == relatedKeywords[0].keyword ? "error" : "success"
        }
      />
    );
  });
  var relatedAdjectiveList = relatedAdjectives
    .slice(0, 5)
    .map((keyword: any) => {
      var barLength = (keyword.count / relatedAdjectives[0].count) * 100;
      return (
        <WordBarElement
          word={keyword.keyword}
          scaledNumber={barLength}
          icon={<PsychologyAltIcon color={"warning"} />}
          color={"info"}
        />
      );
    });
  var relatedTopicsList = relatedTopics.slice(0, 5).map((topic: any) => {
    var barLength = (topic.points / relatedTopics[0].points) * 100;
    return (
      <WordBarElement
        word={topic.topic}
        scaledNumber={barLength}
        icon={<CategoryIcon color={"error"} />}
        color={"secondary"}
      />
    );
  });

  var relatedPeopleList = relatedPeople.slice(0, 5).map((person: any) => {
    var barLength = (person.points / relatedPeople[0].points) * 100;
    return (
      <WordBarElement
        word={person.token}
        scaledNumber={barLength}
        icon={<PersonIcon color={"warning"} />}
        color={person.token == relatedKeywords[0].keyword ? "error" : "success"}
        barWidth={25}
        fontSize={13}
      />
    );
  });

  var relatedPeopleData = relatedPeople.slice(0, 7).map((person: any) => {
    return {
      name: person.token,
      points: person.points,
      color: "#2e7d32",
    };
  });

  var relatedOrganizationsData = relatedOrganizations
    .slice(0, 7)
    .map((org: any) => {
      return {
        name: org.token,
        points: org.points,
        color: "#0288d1",
      };
    });

  var relatedLocationsData = relatedLocations.slice(0, 7).map((loc: any) => {
    return {
      name: loc.token,
      points: loc.points,
      color: "#9c27b0",
    };
  });

  var bubbleData = relatedPeopleData.concat(
    relatedOrganizationsData,
    relatedLocationsData
  );

  var relatedLocationsList = relatedLocations
    .slice(0, 5)
    .map((location: any) => {
      var barLength = (location.points / relatedLocations[0].points) * 100;
      return (
        <WordBarElement
          word={location.token}
          scaledNumber={barLength}
          icon={<LocationOnIcon color={"error"} />}
          color={
            location.token == relatedKeywords[0].keyword ? "error" : "secondary"
          }
          barWidth={25}
          fontSize={13}
        />
      );
    });

  var relatedOrganizationsList = relatedOrganizations
    .slice(0, 5)
    .map((organization: any) => {
      var barLength =
        (organization.points / relatedOrganizations[0].points) * 100;
      return (
        <WordBarElement
          word={organization.token}
          scaledNumber={barLength}
          icon={<BusinessIcon color={"action"} />}
          color={
            organization.token == relatedKeywords[0].keyword ? "error" : "info"
          }
          barWidth={25}
          fontSize={13}
        />
      );
    });
  const dataLineChart = {
    labels: singleField(keywordDetail.appearances, "day").slice(-5),
    datasets: [
      {
        data: singleField(keywordDetail.appearances, "count").slice(-5),
        label: "Số lần được nhắc đến",
        fill: true,
        backgroundColor: "rgba(75,192,192,0.2)",
        borderColor: "rgba(75,192,192,1)",
      },
    ],
  };
  const options = curveLineOptions();
  options.scales = {
    display: false,
    x: {
      min: 0,
      grid: {
        display: false,
      },
    },
    y: {
      min: 0,
      grid: {
        display: false,
      },
    },
  };
  options.plugins.legend.display = false;

  return (
    <Grid container xs={12}>
      <PageHeader text={t("keyword:keyword_portrait")}></PageHeader>
      {adjacentKeyword.length > 0 &&
      chosenKeyword.length > 0 &&
      adjacentKeyword != chosenKeyword ? (
        <KeywordPairPopup
          keyword={chosenKeyword}
          adjacentKeyword={adjacentKeyword}
          days={8}
          open={keywordPairDetailPopup}
          onClose={() => {
            setKeywordPairDetailPopup(false);
          }}
        />
      ) : (
        <div></div>
      )}
      <Grid container xs={12}>
        <Grid item xs={0.75}></Grid>
        <Grid item xs={10.5}>
          <Paper
            component="form"
            className="grey-hover"
            sx={{
              p: "1px 2px",
              display: "flex",
              alignItems: "center",
              margin: "auto",
              width: "100%",
            }}
          >
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                fontSize: "28px !important",
                textAlign: "center",
              }}
              value={currentText}
              onKeyPress={(event: any) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  setChosenKeyword(currentText);
                }
              }}
              onChange={(event: any) => {
                setCurrentText(event.target.value);
              }}
              placeholder={t("whatsnew:search_box_placeholder").toString()}
            />
            <IconButton
              type="button"
              sx={{ p: "10px" }}
              aria-label="search"
              onClick={() => {
                setChosenKeyword(currentText);
              }}
            >
              <SearchIcon />
            </IconButton>
          </Paper>
        </Grid>

        <Grid item xs={0.75}></Grid>
      </Grid>
      <Grid container xs={12} marginTop={4}>
        <Grid item xs={0.75}></Grid>
        <Grid item xs={3.25} className="white">
          <WordBubbleWrapper
            data={bubbleData}
            width={500}
            height={500}
            onBubbleClick={(bubble) => {
              setAdjacentKeyword(bubble);
              setKeywordPairDetailPopup(true);
            }}
          />
        </Grid>
        <Grid item xs={2.4} padding={1} className="white" position={"relative"}>
          <Typography
            variant="h6"
            align="center"
            marginLeft={"15px"}
            marginTop={7}
            fontWeight={600}
          >
            {t("keyword:related_people")}
          </Typography>
          <List sx={{ padding: "0px", marginTop: "10px" }}>
            {relatedPeopleList}
          </List>
        </Grid>
        <Grid item xs={2.4} padding={1} className="white">
          <Typography
            variant="h6"
            align="center"
            marginLeft={"15px"}
            fontWeight={600}
            marginTop={7}
          >
            {t("keyword:related_organizations")}
          </Typography>
          <List sx={{ padding: "0px", marginTop: "10px" }}>
            {relatedOrganizationsList}
          </List>
        </Grid>
        <Grid item xs={2.4} padding={1} className="white">
          <Typography
            variant="h6"
            align="center"
            marginLeft={"15px"}
            fontWeight={600}
            marginTop={7}
          >
            {t("keyword:related_locations")}
          </Typography>
          <List sx={{ padding: "0px", marginTop: "10px" }}>
            {relatedLocationsList}
          </List>
        </Grid>
        <Grid item xs={0.75}></Grid>
      </Grid>
      <Grid container xs={12} spacing={0} marginTop={4}>
        <Grid item xs={0.75}></Grid>

        <Grid item xs={0.4}></Grid>

        <Grid item xs={0.4}></Grid>

        <Grid item xs={0.75}></Grid>
      </Grid>
      <Grid container xs={12} spacing={0} marginTop={4}>
        <Grid item xs={0.75}></Grid>
        <Grid item xs={3.25} padding={2} className="grid-border white">
          <Typography
            variant="h6"
            align="center"
            marginLeft={"15px"}
            fontWeight={600}
          >
            {t("keyword:related_keywords")}
          </Typography>
          <List sx={{ padding: "0px" }}>{relatedKeywordList}</List>
        </Grid>
        <Grid item xs={0.4}></Grid>
        <Grid item xs={3.2} padding={2} className="grid-border white">
          <Typography
            variant="h6"
            align="center"
            marginLeft={"15px"}
            fontWeight={600}
          >
            {t("keyword:related_adjectives")}
          </Typography>
          <List sx={{ padding: "0px" }}>{relatedAdjectiveList}</List>
        </Grid>
        <Grid item xs={0.4}></Grid>
        <Grid item xs={3.25} padding={2} className="grid-border white">
          <Typography
            variant="h6"
            align="center"
            marginLeft={"15px"}
            fontWeight={600}
          >
            {t("keyword:related_topics")}
          </Typography>
          <List sx={{ padding: "0px" }}>{relatedTopicsList}</List>
        </Grid>
        <Grid item xs={0.75}></Grid>
      </Grid>
      <Grid container xs={12} spacing={0} marginTop={3}>
        <Grid item xs={0.75}></Grid>
        <Grid
          item
          xs={3.25}
          className="grid-border white"
          textAlign={"center"}
          padding={2}
        >
          <NumberBox
            title={t("keyword:average_headline_time")}
            variant={"h3"}
            number={
              Math.round(averageTimeOnHeadlines) + " " + t("common:minutes")
            }
            icon={
              <BrowseGalleryIcon
                sx={{ width: "40px", height: "40px", color: "#81d4fa" }}
              />
            }
            subtitle={t("common:derived_from_this_week")}
          />
        </Grid>
        <Grid item xs={0.4}></Grid>
        <Grid
          item
          xs={3.2}
          padding={2}
          className="grid-border white"
          textAlign={"center"}
        >
          <NumberBox
            title={t("keyword:appearances_today")}
            variant={"h3"}
            number={appearancesToday}
            icon={
              <EmojiPeopleIcon
                color="warning"
                sx={{ width: "40px", height: "40px" }}
              />
            }
            subtitle={t("common:derived_from_today")}
          />
        </Grid>
        <Grid item xs={0.4}></Grid>
        <Grid
          item
          xs={3.25}
          padding={2}
          className="grid-border white"
          textAlign={"center"}
        >
          <NumberBox
            title={t("keyword:appearances_week")}
            number={appearancesThisWeek}
            variant={"h3"}
            icon={
              <AutoGraphIcon
                color="success"
                sx={{ width: "40px", height: "40px" }}
              />
            }
            subtitle={t("common:derived_from_this_week")}
          />
        </Grid>
        <Grid item xs={0.75}></Grid>
      </Grid>
      <Grid container xs={12} spacing={0} marginTop={4}>
        <Grid item xs={0.75}></Grid>
        <Grid item xs={3.25} padding={2} className="grid-border white">
          <Typography
            variant="h6"
            align="center"
            fontWeight={600}
            marginBottom={6}
          >
            {t("common:overall_sentiment") + " " + t("common:today")}
          </Typography>
          <SentimentGauge
            minHeight={20}
            sentiment={keywordDetail.overallSentiment}
          ></SentimentGauge>
        </Grid>
        <Grid item xs={0.4}></Grid>
        <Grid
          item
          xs={3.2}
          padding={2}
          className="grid-border white"
          textAlign={"center"}
        >
          <RankingNumber
            number={
              keywordDetail.rankingToday ? keywordDetail.rankingToday : 100000
            }
            title={t("keyword:ranking_based_on_popularity")}
            subtitle={t("common:derived_from_today")}
            variant={"h3"}
          />
          <div style={{ marginTop: "20px" }}></div>
          <RankingNumber
            number={
              keywordDetail.appearanceRankingToday
                ? keywordDetail.appearanceRankingToday
                : 100000
            }
            title={t("keyword:ranking_based_on_appearances")}
            subtitle={t("common:derived_from_this_week")}
            variant={"h3"}
          />
        </Grid>
        <Grid item xs={0.4}></Grid>
        <Grid item xs={3.25} padding={2} className="grid-border white">
          <Typography variant="h6" align="center" fontWeight={600}>
            {t("keyword:frequency_of_appearance")}
          </Typography>
          <Line height={120} data={dataLineChart} options={options}></Line>
        </Grid>
        <Grid item xs={0.75}></Grid>
      </Grid>
    </Grid>
  );
}
